import girderEvents from '@girder/core/events';

export default girderEvents;



// WEBPACK FOOTER //
// ./~/@girder/histomicsui/events.js